import { Component } from 'react';
import PropTypes from 'prop-types';

// Lỗi trong tính năng đăng ký lưu trú KHÔNG được phép làm trắng màn hình toàn app.
// MainLayout render cho cả bốn bộ route (hạnh sinh, BQL, điểm danh, tài khoản chưa duyệt)
// nên bất cứ thứ gì gắn vào đó đều phải tự chịu lỗi của mình.
class DangKyLuuTruErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Lỗi trong tính năng đăng ký lưu trú (đã chặn, app vẫn chạy):', error, errorInfo);
    }

    render() {
        if (this.state.hasError) return null;

        return this.props.children;
    }
}

DangKyLuuTruErrorBoundary.propTypes = {
    children: PropTypes.node
};

export default DangKyLuuTruErrorBoundary;
